export default __webpack_public_path__ + "static/media/prepare_prescription.8e260657.svg";